import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";

class SelectedOrganizationValueIdentifier {
    public static generateIdentifier(licenceOrganizationRule: LicenceOrganisationRule): string {
        if (!licenceOrganizationRule)
            return "";

        return `${licenceOrganizationRule.CountryCode}_${licenceOrganizationRule.StateCode}_${licenceOrganizationRule.OrganisationCode}`;
    }

    public static parseIdentifier(identifier: string): { countryCode: string, stateCode: string, orgCode: string } {
        const parts = identifier.split("_", 3);
        return {
            countryCode: parts[0],
            stateCode: parts[1],
            orgCode: parts[2]
        };
    }
}

export { SelectedOrganizationValueIdentifier };
